<template>
    <div class="d-flex flex-column h-100">
        <div class="item d-flex flex-column">
            <router-link :to="{ path: seeAllLink }" class="h-100">
                <div class="see-all d-flex flex-column justify-content-center align-items-center py-5 text-center h-100">
                    <i :class="icon" class="fa fa-3x"></i>
                    <h6 class="mt-3 mb-0">{{ title }}</h6>
                </div>
            </router-link>
            <router-link v-if="order" :to="{ path: `orders/${order.id}` }" class="text-center">
                <div class="item-footer">
                    <p class="hint m-0">Last Visited</p>
                    {{ order.id }}
                </div>
            </router-link>
            <router-link v-if="user" :to="{ path: `users/${user.id}` }" class="text-center">
                <div class="item-footer">
                    <p class="hint m-0">Last Visited</p>
                    {{ user[USERS.fields.email] }}
                </div>
            </router-link>
            <router-link v-if="addTitle" :to="{ path: addLink }" class="text-center">
                <div class="item-footer">
                    <i class="fa fa-plus mr-2"></i>
                    {{ addTitle }}
                </div>
            </router-link>
        </div>
    </div>
</template>
<script>
import { USERS } from 'db'
export default {
    props: {
        icon: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        seeAllLink: {
            type: String,
            default: ''
        },
        addTitle: {
            type: String,
            default: ''
        },
        addLink: {
            type: String,
            default: ''
        },
        order: {
            type: [Object, Boolean],
            default: false
        },
        user: {
            type: [Object, Boolean],
            default: false
        }
    },
    data() {
        return {
            USERS
        }
    }
}
</script>
<style lang="scss" scoped>
.item {
    margin-bottom: 3rem;
    transition: 0.15s;
    position: relative;
    background: #fff;
    border: 1px solid #ddd;
    box-shadow: 1px 1px 8px #ddd;
}
.item:hover {
    box-shadow: 1px 1px 6px #ccc;
}
.item-footer {
    transition: 0.15s;
    padding: 0.5rem 1.5rem;
    background: #fafafa;
    border-top: 1px solid #eaeaea;
}
.see-all:hover > i {
    animation-name: rubberBand;
    -webkit-animation-duration: 0.4s;
    animation-duration: 0.4s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}
a {
    color: #444;
}
a:hover .item-footer {
    background: #f5f5f5;
    border-top: 1px solid #e5e5e5;
    color: #51cbce;
}
a h6 {
    display: inline-block;
}
</style>
